// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p,
h1 {
  margin: unset;
}

ion-header {
  box-shadow: none;
}

.toolbar {
  background: var(--background-default);
  flex-wrap: nowrap !important;
  display: flex;
}
.toolbar p {
  color: white;
  font-size: 10px;
}

.category-block {
  background: transparent;
}

ion-content {
  background: transparent !important;
  --background: transparent !important;
}

ion-icon.brand-logo {
  width: 140px;
  height: 18px;
}

.main {
  overflow: auto;
}

.item-responsive {
  width: 100%;
}
@media (min-width: 991px) {
  .item-responsive {
    width: calc(33.333% - 10px);
    margin: 0 5px 10px;
  }
}

ion-searchbar {
  padding-inline-end: 25px;
  padding-inline-start: 25px;
  --placeholder-color: var(--ion-color-primary);
  --placeholder-opacity: 1;
  --color: var(--ion-color-primary);
  --icon-color: var(--ion-color-primary);
  --border-radius: 10px;
  --border: none;
  --background: rgba(255, 255, 255, 0.15);
}
@media (min-width: 991px) {
  ion-searchbar {
    width: auto;
  }
}

.menu-heading {
  padding-top: 10px;
  background: #e7f0f1;
  padding-bottom: 10px;
}
@media (min-width: 991px) {
  .menu-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7f0f1;
  }
}

.list-title {
  margin-bottom: 15px;
}

.orders {
  overflow: auto;
  flex: 1;
  padding-bottom: 10px;
}

.items-wrap h3 {
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: bolder;
}
.items-wrap:first-of-type {
  padding-top: 12px;
}
.items-wrap:last-of-type {
  padding-bottom: 400px;
}
.items-wrap .category-wrap {
  margin-bottom: 22px;
  padding-inline: 7px;
}
.items-wrap .articles-wrapper {
  padding-inline: 16px;
}
@media (min-width: 991px) {
  .items-wrap .articles-wrapper {
    margin: 0 -16px;
  }
}

.main-row {
  height: 100%;
  overflow: hidden;
}

app-order-content {
  display: block;
  height: 100%;
}

.order-col {
  min-width: 380px;
}

.category-header {
  height: 80px;
  width: 100%;
  position: relative;
}
.category-header .category-headr-img {
  height: 80px;
  width: 100%;
  object-fit: cover;
  opacity: 0.7;
  z-index: 0.6;
}
.category-header h3 {
  position: absolute;
  z-index: 10;
  top: 50%;
  color: var(--ion-color-primary);
  left: 25px;
  transform: translateY(-50%);
}
@media (min-width: 991px) {
  .category-header {
    margin-top: 20px;
  }
}

.category-info {
  padding-left: 16px;
  height: 77px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  background: #f5f5f5;
}
.category-info .category-name {
  width: 100%;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
  z-index: 9999;
  font-size: 24px;
  line-height: 100%;
  vertical-align: middle;
  text-transform: capitalize;
  letter-spacing: 0.02em;
  color: #212326;
}
.category-info .category-description {
  z-index: 1;
  font-family: AppFontSemiBold;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  color: var(--ion-color-secondary);
  margin-top: 7px;
}
.category-info ion-img {
  object-fit: cover;
  right: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  position: absolute;
}

.header-wrap {
  padding-left: 11px;
}

.padding-end {
  padding-right: 11px;
}

.footer-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  backdrop-filter: blur(4px);
  background: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);
}
@media (min-width: 991px) {
  .footer-btn {
    display: none;
  }
}

.category-list {
  display: flex;
  align-items: center;
  transition: 1s linear;
  opacity: 1;
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  background-color: transparent;
  height: 71px;
  padding-inline: 20px;
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list .category {
  flex: 0 0 auto;
}
.category-list .category:first-child {
  margin-left: 15px;
}
.category-list .category:last-child {
  margin-right: 15px;
}

.menu-heading {
  padding-top: 10px;
  background: #6b5f4c;
  padding-bottom: 10px;
}
@media (min-width: 991px) {
  .menu-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7f0f1;
  }
}

.search-block {
  height: 71px;
  display: flex;
  align-items: center;
  opacity: 1;
  transition: 1s linear;
}

.hidden {
  opacity: 0;
  display: none;
  transition: 1s linear;
}

.main-row {
  height: 100%;
  overflow: hidden;
}

ion-chip {
  --icon-color: var(--ion-color-primary);
  height: 41px;
  background: transparent;
  border: 1px solid var(--ion-color-primary);
  transition: 200ms linear;
  min-width: 41px;
  flex-direction: column;
  padding: 0 15px !important;
  border-radius: var(--radius-default);
  justify-content: center;
}
ion-chip ion-label {
  font-size: 14px;
  margin: 0;
  color: var(--color-black);
  font-family: AppFontMedium, sans-serif;
}
ion-chip.selected {
  transition: 200ms linear;
  background: var(--ion-color-primary);
}
ion-chip.selected ion-label {
  color: var(--color-white);
}
ion-chip .icon {
  height: 17px;
  width: 17px;
  margin: 0;
}

.service-not-available-container {
  --padding-start: 20px !important;
  --padding-end: 10px;
  --padding-top: 10px;
  --padding-bottom: 10px;
}
.service-not-available-container ion-icon {
  color: #fff !important;
}

.banner-row {
  height: 48px;
  overflow: hidden;
  transition: transform 1s ease-in-out, height 1s ease-in-out;
}
@media (max-width: 992px) {
  .banner-row {
    height: 60px;
  }
}
.banner-row.hide {
  height: 0;
  transform: rotateX(45deg) translate(0, -150%);
}

.allergen-banner {
  height: 100%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px !important;
  padding-right: 16px;
}
.allergen-banner ion-icon {
  fill: #000;
  margin-right: 15px;
  height: 27px;
  width: 32px;
}
.allergen-banner .info {
  width: 100%;
  margin: 0;
  padding-block: 5px;
  font-family: AppFont !important;
  font-size: 10px !important;
  line-height: 13.2px !important;
  color: #212326 !important;
  text-wrap: balance;
}
.allergen-banner a {
  font-family: AppFontSemiBold;
  font-size: 10px;
  color: var(--ion-color-secondary);
  text-decoration: underline;
}

.expand-block {
  position: fixed;
  height: 100vh;
  width: 100vw;
  right: -100%;
  top: 0;
  background: rgba(0, 0, 0, 0.1019607843);
  z-index: 10;
}
@media (max-width: 992px) {
  .expand-block {
    display: none;
  }
}
.expand-block.show {
  right: 0%;
}

.sidebar {
  position: absolute;
  right: -100%;
  top: 0;
  width: 35vw;
  height: 100vh;
  background: #fff;
  z-index: 11;
  display: flex;
  flex-direction: column;
  transition: right 0.3s ease-in-out;
}
@media (max-width: 992px) {
  .sidebar {
    display: none;
  }
}
.sidebar.show {
  right: 0%;
}

app-order-content {
  display: block;
  height: 100%;
  background: #f2f2f2;
}

.fixed-notification {
  position: fixed;
  bottom: 86px;
  left: 50%;
  transform: translateX(-50%);
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(30, 30, 28, 0.5803921569);
  backdrop-filter: blur(4px);
  z-index: 9999;
  opacity: 0;
  transition: 0.3s ease;
}
@media (min-width: 991px) {
  .fixed-notification {
    bottom: 0px;
  }
}
.fixed-notification::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -12px;
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-top: 12px solid rgba(30, 30, 28, 0.5803921569);
  backdrop-filter: blur(4px);
}
.fixed-notification ::ng-deep.inner-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #fff;
  padding: 0 10px;
}
.fixed-notification ::ng-deep.inner-text span {
  font-family: AppFontSemiBold;
  color: #fff;
}

.placeholder-item {
  height: 200px;
}

.fixed-notification.show-item {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;;EAEC,aAAA;AAAD;;AAGA;EACC,gBAAA;AAAD;;AAGA;EACC,qCAAA;EACA,4BAAA;EACA,aAAA;AAAD;AACC;EACC,YAAA;EACA,eAAA;AACF;;AAGA;EACC,uBAAA;AAAD;;AAEA;EACC,kCAAA;EACA,oCAAA;AACD;;AACA;EACC,YAAA;EACA,YAAA;AAED;;AACA;EACC,cAAA;AAED;;AACA;EACC,WAAA;AAED;ACtCE;EDmCF;IAGE,2BAAA;IACA,kBAAA;EAIA;AACF;;AADA;EACC,wBAAA;EACA,0BAAA;EACA,6CAAA;EACA,wBAAA;EACA,iCAAA;EACA,sCAAA;EACA,qBAAA;EACA,cAAA;EACA,uCAAA;AAID;ACxDE;ED2CF;IAWE,WAAA;EAMA;AACF;;AAJA;EACC,iBAAA;EACA,mBAAA;EACA,oBAAA;AAOD;ACnEE;EDyDF;IAKE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,gCAAA;EASA;AACF;;AANA;EACC,mBAAA;AASD;;AANA;EACC,cAAA;EACA,OAAA;EACA,oBAAA;AASD;;AALC;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;AAQF;AALC;EACC,iBAAA;AAOF;AAJC;EACC,qBAAA;AAMF;AAHC;EACC,mBAAA;EACA,mBAAA;AAKF;AAFC;EACC,oBAAA;AAIF;ACxGE;EDmGD;IAGE,eAAA;EAMD;AACF;;AAFA;EACC,YAAA;EACA,gBAAA;AAKD;;AAFA;EACC,cAAA;EACA,YAAA;AAKD;;AAFA;EACC,gBAAA;AAKD;;AAHA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAMD;AALC;EACC,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AAOF;AALC;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,+BAAA;EACA,UAAA;EACA,2BAAA;AAOF;AChJE;EDwHF;IAoBE,gBAAA;EAQA;AACF;;AANA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AASD;AAPC;EACC,WAAA;EAEA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,sBAAA;EAEA,cAAA;AAKF;AAFC;EACC,UAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EAEA,iCAAA;EAEA,eAAA;AAEF;AACC;EACC,iBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAGA;EACC,kBAAA;AAAD;;AAEA;EACC,mBAAA;AACD;;AAEA;EACC,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,0BAAA;EACA,4GAAA;AACD;ACrNE;ED6MF;IASE,aAAA;EAGA;AACF;;AADA;EACC,aAAA;EACA,mBAAA;EAEA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;EAEA,6BAAA;EACA,YAAA;EACA,oBAAA;AAED;AAAC;EACC,aAAA;AAEF;AACC;EACC,cAAA;AACF;AACE;EACC,iBAAA;AACH;AAEE;EACC,kBAAA;AAAH;;AAIA;EACC,iBAAA;EACA,mBAAA;EACA,oBAAA;AADD;AC3PE;EDyPF;IAKE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,gCAAA;EACA;AACF;;AAKA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EAEA,UAAA;EACA,qBAAA;AAHD;;AAKA;EACC,UAAA;EACA,aAAA;EACA,qBAAA;AAFD;;AAKA;EACC,YAAA;EACA,gBAAA;AAFD;;AAIA;EACC,sCAAA;EACA,YAAA;EAEA,uBAAA;EACA,0CAAA;EACA,wBAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,oCAAA;EAGA,uBAAA;AAJD;AAMC;EACC,eAAA;EACA,SAAA;EACA,yBAAA;EACA,sCAAA;AAJF;AAOC;EACC,wBAAA;EACA,oCAAA;AALF;AAOE;EACC,yBAAA;AALH;AASC;EACC,YAAA;EACA,WAAA;EACA,SAAA;AAPF;;AAWA;EACC,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AARD;AASC;EACC,sBAAA;AAPF;;AAWA;EACC,YAAA;EACA,gBAAA;EACA,2DACC;AATF;AC/TE;EDoUF;IAOE,YAAA;EARA;AACF;AAUC;EACC,SAAA;EACA,6CAAA;AARF;;AAYA;EACC,YAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mBAAA;AAVD;AAYC;EACC,UAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAVF;AAaC;EACC,WAAA;EACA,SAAA;EACA,kBAAA;EAEA,+BAAA;EACA,0BAAA;EACA,8BAAA;EAEA,yBAAA;EACA,kBAAA;AAbF;AAgBC;EACC,4BAAA;EACA,eAAA;EACA,iCAAA;EACA,0BAAA;AAdF;;AAkBA;EACC,eAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,uCAAA;EAEA,WAAA;AAhBD;AClXE;ED0XF;IAUE,aAAA;EAdA;AACF;AAeC;EACC,SAAA;AAbF;;AAiBA;EACC,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EAEA,aAAA;EACA,sBAAA;EAEA,kCAAA;AAhBD;ACvYE;ED2YF;IAcE,aAAA;EAdA;AACF;AAeC;EACC,SAAA;AAbF;;AAiBA;EACC,cAAA;EACA,YAAA;EACA,mBAAA;AAdD;;AAiBA;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EAEA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,0CAAA;EACA,0BAAA;EAEA,aAAA;EACA,UAAA;EACA,qBAAA;AAjBD;AC5aE;ED4aF;IAmBE,WAAA;EAfA;AACF;AAiBC;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,qDAAA;EACA,0BAAA;AAfF;AAkBC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AAhBF;AAiBE;EACC,4BAAA;EACA,WAAA;AAfH;;AAoBA;EACC,aAAA;AAjBD;;AAoBA;EACC,UAAA;AAjBD","sourcesContent":["@use '../../../theme/mixins' as *;\np,\nh1 {\n\tmargin: unset;\n}\n\nion-header {\n\tbox-shadow: none;\n}\n\n.toolbar {\n\tbackground: var(--background-default);\n\tflex-wrap: nowrap !important;\n\tdisplay: flex;\n\tp {\n\t\tcolor: white;\n\t\tfont-size: 10px;\n\t}\n}\n\n.category-block {\n\tbackground: transparent;\n}\nion-content {\n\tbackground: transparent !important;\n\t--background: transparent !important;\n}\nion-icon.brand-logo {\n\twidth: 140px;\n\theight: 18px;\n}\n\n.main {\n\toverflow: auto;\n}\n\n.item-responsive {\n\twidth: 100%;\n\t@include desktop {\n\t\twidth: calc(33.333% - 10px);\n\t\tmargin: 0 5px 10px;\n\t}\n}\n\nion-searchbar {\n\tpadding-inline-end: 25px;\n\tpadding-inline-start: 25px;\n\t--placeholder-color: var(--ion-color-primary);\n\t--placeholder-opacity: 1;\n\t--color: var(--ion-color-primary);\n\t--icon-color: var(--ion-color-primary);\n\t--border-radius: 10px;\n\t--border: none;\n\t--background: rgba(255, 255, 255, 0.15);\n\t@include desktop {\n\t\twidth: auto;\n\t}\n}\n.menu-heading {\n\tpadding-top: 10px;\n\tbackground: #e7f0f1;\n\tpadding-bottom: 10px;\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 1px solid #e7f0f1;\n\t}\n}\n\n.list-title {\n\tmargin-bottom: 15px;\n}\n\n.orders {\n\toverflow: auto;\n\tflex: 1;\n\tpadding-bottom: 10px;\n}\n\n.items-wrap {\n\th3 {\n\t\tmargin-top: 0;\n\t\tmargin-bottom: 12px;\n\t\tfont-weight: bolder;\n\t}\n\n\t&:first-of-type {\n\t\tpadding-top: 12px;\n\t}\n\n\t&:last-of-type {\n\t\tpadding-bottom: 400px;\n\t}\n\n\t.category-wrap {\n\t\tmargin-bottom: 22px;\n\t\tpadding-inline: 7px;\n\t}\n\n\t.articles-wrapper {\n\t\tpadding-inline: 16px;\n\t\t@include desktop {\n\t\t\tmargin: 0 -16px;\n\t\t}\n\t}\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n}\n\n.order-col {\n\tmin-width: 380px;\n}\n.category-header {\n\theight: 80px;\n\twidth: 100%;\n\tposition: relative;\n\t.category-headr-img {\n\t\theight: 80px;\n\t\twidth: 100%;\n\t\tobject-fit: cover;\n\t\topacity: 0.7;\n\t\tz-index: 0.6;\n\t}\n\th3 {\n\t\tposition: absolute;\n\t\tz-index: 10;\n\t\ttop: 50%;\n\t\tcolor: var(--ion-color-primary);\n\t\tleft: 25px;\n\t\ttransform: translateY(-50%);\n\t}\n\t@include desktop {\n\t\tmargin-top: 20px;\n\t}\n}\n.category-info {\n\tpadding-left: 16px;\n\theight: 77px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: flex-start;\n\tposition: relative;\n\tbackground: #f5f5f5;\n\n\t.category-name {\n\t\twidth: 100%;\n\n\t\tword-break: break-word;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tmargin: 0px;\n\t\tz-index: 9999;\n\n\t\tfont-size: 24px;\n\t\tline-height: 100%;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\n\t\tletter-spacing: 0.02em;\n\n\t\tcolor: #212326;\n\t}\n\n\t.category-description {\n\t\tz-index: 1;\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 12px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0;\n\t\tvertical-align: middle;\n\n\t\tcolor: var(--ion-color-secondary);\n\n\t\tmargin-top: 7px;\n\t}\n\n\tion-img {\n\t\tobject-fit: cover;\n\t\tright: 0px;\n\t\ttop: 0px;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t}\n}\n\n.header-wrap {\n\tpadding-left: 11px;\n}\n.padding-end {\n\tpadding-right: 11px;\n}\n\n.footer-btn {\n\tposition: fixed;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpadding: 20px;\n\tbackdrop-filter: blur(4px);\n\tbackground: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n.category-list {\n\tdisplay: flex;\n\talign-items: center;\n\n\ttransition: 1s linear;\n\topacity: 1;\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none; /* Firefox */\n\n\tbackground-color: transparent;\n\theight: 71px;\n\tpadding-inline: 20px;\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t.category {\n\t\tflex: 0 0 auto;\n\n\t\t&:first-child {\n\t\t\tmargin-left: 15px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-right: 15px;\n\t\t}\n\t}\n}\n.menu-heading {\n\tpadding-top: 10px;\n\tbackground: #6b5f4c;\n\tpadding-bottom: 10px;\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 1px solid #e7f0f1;\n\t}\n}\n// .first {\n// \tmargin-top: 10px;\n// }\n\n.search-block {\n\theight: 71px;\n\tdisplay: flex;\n\talign-items: center;\n\n\topacity: 1;\n\ttransition: 1s linear;\n}\n.hidden {\n\topacity: 0;\n\tdisplay: none;\n\ttransition: 1s linear;\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n}\nion-chip {\n\t--icon-color: var(--ion-color-primary);\n\theight: 41px;\n\n\tbackground: transparent;\n\tborder: 1px solid var(--ion-color-primary);\n\ttransition: 200ms linear;\n\tmin-width: 41px;\n\tflex-direction: column;\n\tpadding: 0 15px !important;\n\tborder-radius: var(--radius-default);\n\t// text-transform: uppercase;\n\n\tjustify-content: center;\n\n\tion-label {\n\t\tfont-size: 14px;\n\t\tmargin: 0;\n\t\tcolor: var(--color-black);\n\t\tfont-family: AppFontMedium, sans-serif;\n\t}\n\n\t&.selected {\n\t\ttransition: 200ms linear;\n\t\tbackground: var(--ion-color-primary);\n\n\t\tion-label {\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n\n\t.icon {\n\t\theight: 17px;\n\t\twidth: 17px;\n\t\tmargin: 0;\n\t}\n}\n\n.service-not-available-container {\n\t--padding-start: 20px !important;\n\t--padding-end: 10px;\n\t--padding-top: 10px;\n\t--padding-bottom: 10px;\n\tion-icon {\n\t\tcolor: #fff !important;\n\t}\n}\n\n.banner-row {\n\theight: 48px;\n\toverflow: hidden;\n\ttransition:\n\t\ttransform 1s ease-in-out,\n\t\theight 1s ease-in-out;\n\t@include mobile {\n\t\theight: 60px;\n\t}\n\n\t&.hide {\n\t\theight: 0;\n\t\ttransform: rotateX(45deg) translate(0, -150%);\n\t}\n}\n\n.allergen-banner {\n\theight: 100%;\n\tbackground: #f5f5f5;\n\t// height: 39px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding-left: 16px !important;\n\tpadding-right: 16px;\n\n\tion-icon {\n\t\tfill: #000;\n\t\tmargin-right: 15px;\n\t\theight: 27px;\n\t\twidth: 32px;\n\t}\n\n\t.info {\n\t\twidth: 100%;\n\t\tmargin: 0;\n\t\tpadding-block: 5px;\n\n\t\tfont-family: AppFont !important;\n\t\tfont-size: 10px !important;\n\t\tline-height: 13.2px !important;\n\n\t\tcolor: #212326 !important;\n\t\ttext-wrap: balance;\n\t}\n\n\ta {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 10px;\n\t\tcolor: var(--ion-color-secondary);\n\t\ttext-decoration: underline;\n\t}\n}\n\n.expand-block {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100vw;\n\tright: -100%;\n\ttop: 0;\n\tbackground: #0000001a;\n\n\tz-index: 10;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t&.show {\n\t\tright: 0%;\n\t}\n}\n\n.sidebar {\n\tposition: absolute;\n\tright: -100%;\n\ttop: 0;\n\twidth: 35vw;\n\theight: 100vh;\n\tbackground: #fff;\n\tz-index: 11;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\ttransition: right 0.3s ease-in-out;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t&.show {\n\t\tright: 0%;\n\t}\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n\tbackground: #f2f2f2;\n}\n\n.fixed-notification {\n\tposition: fixed;\n\tbottom: 86px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\n\theight: 60px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tbackground: #1e1e1c94;\n\tbackdrop-filter: blur(4px);\n\n\tz-index: 9999;\n\topacity: 0;\n\ttransition: 0.3s ease;\n\t@include desktop {\n\t\tbottom: 0px;\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\tbottom: -12px;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-left: 14px solid transparent;\n\t\tborder-right: 14px solid transparent;\n\t\tborder-top: 12px solid #1e1e1c94;\n\t\tbackdrop-filter: blur(4px);\n\t}\n\n\t::ng-deep.inner-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\tcolor: #fff;\n\t\tpadding: 0 10px;\n\t\tspan {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}\n\n.placeholder-item {\n\theight: 200px;\n}\n\n.fixed-notification.show-item {\n\topacity: 1;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
